module.exports = __webpack_public_path__ + "files/8b9a2eb34317d07eb6cd73243666fa36.svg";